/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInSlug: core.serialization.ObjectSchema<serializers.NotInSlug.Raw, Truvity.NotInSlug> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.string()),
    });

export declare namespace NotInSlug {
    export interface Raw {
        values: string[];
    }
}
